import React from 'react';
import { chooseDataStateType } from '../molecules/MaintenanceModalDispLabels';

interface props {
  data: chooseDataStateType;
  setChooseData: (data: chooseDataStateType) => void;
  onToggle: () => void;
}

export const MaintenanceModalDispDeleteLabel: React.FC<props> = (props) => {
  const { data, setChooseData, onToggle } = props;
  return (
    <u>
      <label
        style={{
          cursor: 'pointer'
        }}
        onClick={() => {
          onToggle();
          setChooseData(data);
        }}
      >
        削除
      </label>
    </u>
  );
};
